<template>
	<div id="listInventoryResumeComponent">
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control mr-sm-2 form-control-sm" type="search" placeholder="Buscar articulo" aria-label="Buscar" v-on:keyup.enter="getInventoryResumeLocal(1)" v-model="searchProduct" :disabled="loadingInventories">
				<button class="btn btn-primary my-2 my-sm-0 btn-sm" @click="getInventoryResumeLocal(1)" :disabled="loadingInventories">Buscar</button>
			</div>
			<div class="form-inline">
				<button class="btn btn-link my-2 my-sm-0 btn-sm" @click="downloadInventoryLocal">Descargar </button>
			</div>
		</nav>
		<div>
			<table class="table table-sm table-12 table-striped table-hover">
				<thead>
					<tr>
						<th class="text-center">Codigo</th>
						<th class="text-center">Articulo</th>
						<th class="text-center">Cantidad</th>
						<th class="text-right"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(p, i) in listProductsFilter" :key="i">
						<td>{{  p.id }}</td>
						<td>{{  p.name }}</td>
						<td class="text-right">{{ methodFormatNumber(p.quantity) }}</td>
						<td class="text-right"></td>
					</tr>
				</tbody>
			</table>
			<pagination :pagination="paginationProducts" @getAllList="getInventoryResumeLocal"></pagination>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventories from '@/mixins/inventories'
	import Pagination from '@/components/Pagination.vue'

	export default {
		name: 'ListInventoryResumeComponent',
		mixins: [axiosAction, errors, mixin, inventories],
		props: ['inventoryId'],
		data () {
			return {
				searchProduct: '',
				listProducts: [],
				paginationProducts: []
			}
		},
		components: {
			'pagination': Pagination,
		},
		computed: {
			listProductsFilter() {
				return this.listProducts
			}
		},
		methods: {
			downloadInventoryLocal() {
				this.downloadInventory(this.inventoryId)
			},
			getInventoryResumeLocal(page = 1) {
				this.listProducts = []
				this.paginationProducts = []
				this.getInventoryResume(this.inventoryId, page, this.searchProduct)
			},
			getInventoryResumeResultLocal(response) {
				if(response.data.success == true) {
					this.listProducts = response.data.data
					this.paginationProducts = response.data.paginate
				}
			},
			initComponentLocal() {
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getInventoryResumeResult': this.getInventoryResumeResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
